export enum FeedbackValues {
  ConfusingProduct = 'ConfusingProduct',
  NotSureIfTechSavvyEnough = 'NotSureIfTechSavvyEnough',
  TooLongToGetHardware = 'TooLongToGetHardware',
  UnsureIfWorthTheEffort = 'UnsureIfWorthTheEffort',
  ChangedMind = 'ChangedMind',
  Other = 'Other'
}
